<template>
    <div class="account-block account-block--responsive | u-display--none-desk">
        <div class="u-flex-center">
            <img class="account-block__image" src="../assets/icomoon/SVG/user.svg" />
            <div class="account-block__meta">
                <span class="account-block__name">{{ user.name }}</span>
            </div>
        </div>
        <span>
            <button :class="{ btn__GhostLogin: originalUser }" class="btn btn--blue btn--small" @click="logout">
                <span v-if="!originalUser">
                    {{ trans('action.logout') }}
                </span>
                <span v-else>
                    {{ trans('action.back_to_nova') }}
                </span>
            </button>
        </span>
    </div>
</template>
<script>
import WhiteButton from '../components/WhiteButton.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        WhiteButton
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            originalUser: 'user/originalUser'
        })
    }
};
</script>
